"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportVoucherLinkAuditMutation = exports.useAuditVoucherLinksMutation = exports.useHealStuckOrdersMutation = exports.schedulerApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.schedulerApi = (0, react_1.createApi)({
    reducerPath: "schedulerApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["SchedulerHeal"],
    endpoints: function (builder) { return ({
        healStuckOrders: builder.mutation({
            query: function (body) { return ({
                url: "/v1/scheduler/trigger/heal-stuck-orders",
                method: "POST",
                body: body !== null && body !== void 0 ? body : {},
            }); },
        }),
        auditVoucherLinks: builder.mutation({
            query: function (body) { return ({
                url: "/v1/scheduler/trigger/audit-voucher-links",
                method: "POST",
                body: body !== null && body !== void 0 ? body : {},
            }); },
        }),
        exportVoucherLinkAudit: builder.mutation({
            query: function (body) { return ({
                url: "/v1/scheduler/trigger/audit-voucher-links",
                method: "POST",
                body: __assign(__assign({}, body), { format: "xlsx" }),
                responseHandler: function (response) { return response.blob(); },
            }); },
        }),
    }); },
});
exports.useHealStuckOrdersMutation = exports.schedulerApi.useHealStuckOrdersMutation, exports.useAuditVoucherLinksMutation = exports.schedulerApi.useAuditVoucherLinksMutation, exports.useExportVoucherLinkAuditMutation = exports.schedulerApi.useExportVoucherLinkAuditMutation;
